import { patch, } from 'incremental-dom';
import { createElement } from '../../incdom';
import { timer } from 'rxjs';
import { triggerPageChange } from '../../rxjs';
import './cookie.scss';
var hideCookie = function (delay) {
    timer(delay)
        .subscribe(function (_) {
        var el = document.getElementById('cookie-warning');
        if (el !== null) { // If OK was clicked the cookie warning element may already have been removed
            el.addEventListener('transitionend', function () {
                // FIXME: If OK is clicked during the transition this eventlistener is added twice and the
                // second instance fails because there is no parent node.
                if (el !== null) {
                    el.parentNode.removeChild(el);
                }
            });
            el.style.opacity = '0.0';
        }
    });
};
var setCookie = function (value) {
    document.cookie = "cookie_warning=" + value + "; expires=" + (new Date(Date.now() + 3650 * 864e+5)).toUTCString() + "; path=/";
};
export var cookie = function () {
    function getCook(cookiename) {
        // Get name followed by anything except a semicolon
        var cookiestring = RegExp("" + cookiename + "[^;]+").exec(document.cookie);
        // Return everything after the equal sign, or an empty string if the cookie name not found
        return decodeURIComponent(!!cookiestring ? cookiestring.toString().replace(/^[^=]+./, "") : "");
    }
    if (getCook('cookie_warning').match(/(true|OK)/) === null) {
        var cwel_1 = document.body.appendChild(document.createElement('div'));
        cwel_1.id = 'cookie-warning';
        patch(cwel_1, createElement("fragment", null,
            createElement("div", { class: 'cookie-wrapper' },
                createElement("p", null,
                    "We use cookies",
                    createElement("span", null, "\u00A0to ensure that we give you the best experience on our website"),
                    "."),
                createElement("a", { href: '/policies/privacy', class: 'cookie-learn', onclick: function (event) { triggerPageChange('/policies/privacy'); return false; } },
                    createElement("p", null, "Privacy Policy")),
                createElement("p", { class: 'cookie-confirm', onclick: function (event) { setCookie('OK'); hideCookie(10); } }, "OK"))));
        timer(7000)
            .subscribe(function (s) {
            cwel_1.style.opacity = '1';
            setCookie('true');
            hideCookie(10000);
        });
    }
};
//# sourceMappingURL=index.js.map